import script from "./homePage.vue?vue&type=script&setup=true&lang=js"
export * from "./homePage.vue?vue&type=script&setup=true&lang=js"

import "./homePage.vue?vue&type=style&index=0&id=127d3553&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-127d3553"]])

export default __exports__